import { t } from "@lingui/macro";

import { Button } from "@whoosh/design-system/src/components/controls";
import { StandardModal } from "@whoosh/design-system/src/components/overlay/StandardModal";
import {
  HStack,
  Text,
  VStack,
} from "@whoosh/design-system/src/components/primitive";

import { PatronBookingRateChangeConfirmModalContent } from "./PatronBookingRateChangeConfirmModalContent";

export type PatronBookingRateChangeConfirmModalRateInitializationData = {
  bookingId: string;
  confirmCallback: () => void;
  rateUpdates: {
    targetId: string;
    rateId: string;
    slotTargetId: string;
  }[];
};

export const PatronBookingRateChangeConfirmModal = ({
  isOpen,
  onClose,
  rateInitializationData,
}: {
  isOpen: boolean;
  onClose: (confirm?: boolean) => void;
  rateInitializationData?: PatronBookingRateChangeConfirmModalRateInitializationData;
}) => {
  const handleClose = (confirm?: boolean) => {
    if (confirm) {
      rateInitializationData?.confirmCallback?.();
    }
    onClose(confirm);
  };

  return (
    <StandardModal
      isOpen={isOpen}
      onClose={handleClose}
      upperTitle={t`Rate Change`}
      hideFooterPadding
      content={
        <VStack padding={6} paddingTop={0}>
          <Text color="text-secondary">
            {t`New rates apply for the selected time. Are you sure you want to proceed?`}
          </Text>
          <PatronBookingRateChangeConfirmModalContent
            bookingId={rateInitializationData?.bookingId}
            rateUpdates={rateInitializationData?.rateUpdates ?? []}
          />
        </VStack>
      }
      footerContent={
        <HStack
          justifyContent="space-between"
          padding={6}
          shadowOffset={{
            width: 0,
            height: -4,
          }}
          shadowOpacity={0.08}
          shadowRadius={16}
          shadowColor="black"
          borderRadius="6"
        >
          <Button
            onPress={() => handleClose(false)}
            variant={"secondary"}
            accessibilityLabel={t`Cancel button`}
          >
            {t`Cancel`}
          </Button>
          <Button
            onPress={() => handleClose(true)}
            variant={"main"}
            accessibilityLabel={t`Accept and Move button`}
          >{t`Accept and Move`}</Button>
        </HStack>
      }
    />
  );
};
